import { styled, TableCell } from '@mui/material';

export const StyledTableCell = styled(TableCell)({
  textAlign: 'center',
});
